/**
 * Typed errors for the Connector SDK.
 */

export class ConnectorError extends Error {
  readonly code: string
  readonly connectorId?: string
  readonly cause?: unknown

  constructor(message: string, options?: { code?: string; connectorId?: string; cause?: unknown }) {
    super(message)
    this.name = 'ConnectorError'
    this.code = options?.code ?? 'CONNECTOR_ERROR'
    this.connectorId = options?.connectorId
    this.cause = options?.cause
  }
}

export class ConnectorNotImplementedError extends ConnectorError {
  constructor(connectorId: string, method: string) {
    super(`Connector "${connectorId}" ainda não implementa ${method}()`, {
      code: 'NOT_IMPLEMENTED',
      connectorId,
    })
    this.name = 'ConnectorNotImplementedError'
  }
}

export class ConnectorNotRegisteredError extends ConnectorError {
  constructor(connectorId: string) {
    super(
      `Conector "${connectorId}" não está registrado no ConnectorFactory. Implemente e registre via register().`,
      { code: 'NOT_REGISTERED', connectorId },
    )
    this.name = 'ConnectorNotRegisteredError'
  }
}

export class ConnectorStateError extends ConnectorError {
  constructor(connectorId: string, message: string) {
    super(message, { code: 'INVALID_STATE', connectorId })
    this.name = 'ConnectorStateError'
  }
}

export class ConnectorCapabilityError extends ConnectorError {
  constructor(connectorId: string, capability: string) {
    super(`Conector "${connectorId}" não declara capability ${capability}`, {
      code: 'MISSING_CAPABILITY',
      connectorId,
    })
    this.name = 'ConnectorCapabilityError'
  }
}

export class ConnectorSessionError extends ConnectorError {
  constructor(connectorId: string, message: string, cause?: unknown) {
    super(message, { code: 'SESSION_ERROR', connectorId, cause })
    this.name = 'ConnectorSessionError'
  }
}
